import { keyBy } from 'lodash';
import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

import { formatDateWithLanguageCode, formatTimeWithLanguageCode } from '@commons/utils/date';

const historyColumns = () => [
  {
    name: i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_COLUMN_RELAUNCH_DATE'),
    propertyKey: 'relaunchDate',
  },
  {
    name: i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_COLUMN_RELAUNCH_TIME'),
    propertyKey: 'relaunchTime',
  },
  {
    name: i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_COLUMN_USER'),
    propertyKey: 'user',
  },
  {
    name: i18next.t('GENERAL.STORE', { count: 2 }), // in order to get the plural form of the store name
    propertyKey: 'stores',
  },
  {
    name: i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_COLUMN_START_DATE'),
    propertyKey: 'startDate',
  },
  {
    name: i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_COLUMN_END_DATE'),
    propertyKey: 'endDate',
  },
  {
    name: i18next.t('GENERAL.TIMEZONE'),
    propertyKey: 'userTimezone',
  },
];

export const exportAnalyticsHistory = (analyticsHistoryData, userLanguageCode, stores) => {
  const storesKeyById = keyBy(stores, 'id');

  const formattedData = analyticsHistoryData.map((row) => ({
    ...row,
    relaunchDate: formatDateWithLanguageCode(row.relaunchDate, userLanguageCode),
    relaunchTime: formatTimeWithLanguageCode(row.relaunchTime, userLanguageCode, true),
    user: `${row.firstName} ${row.lastName}`,
    stores: row.storeIds.map((storeId) => storesKeyById[storeId]?.name || '').join(', '),
    startDate: formatDateWithLanguageCode(row.startDate, userLanguageCode),
    endDate: formatDateWithLanguageCode(row.endDate, userLanguageCode),
  }));

  const historySheet = utilsXLS.generateDefaultSheet(
    i18next.t('BACKOFFICE.ANALYTICS.EXPORT_HISTORY_SHEET_NAME'),
    historyColumns(),
    formattedData,
  );

  utilsXLS.makeXLS(i18next.t('BACKOFFICE.ANALYTICS.EXPORT_FILENAME'), [historySheet]);
};
